import { useRouter } from 'next/router'
import { memo, useEffect, useState } from 'react'

import HeaderOverhaul from '@/components/elements/headerOverhaul'

import ContactCards from './contactCards'
import ContactForm from './contactForm'
import LocationCards from './locationCards'

const Contact = ({ data }) => {
  const { header, description, contactCards, locationCardsHeader, locationCards } = data
  const [defaultValues, setDefaultValues] = useState({})
  const router = useRouter()

  useEffect(() => {
    if (!router.query) return
    const { name, email, phone, subject, message } = router.query
    setDefaultValues({
      name,
      email,
      phone,
      subject,
      message
    })
  }, [router.query])

  return (
    <div className="contact-wrapper">
      <HeaderOverhaul header={header} darkBackground />
      <div className="contact-cards">
        <ContactCards cards={contactCards} />
      </div>
      <div className="contact-form">
        <ContactForm defaultValues={defaultValues} description={description} />
      </div>
      <HeaderOverhaul
        className="contact-location-cards-header"
        header={locationCardsHeader}
        subtitle
      />
      <div className="contact-location-cards">
        <LocationCards cards={locationCards} />
      </div>
    </div>
  )
}

export default memo(Contact)
